export const DATE_FORMAT_DD_MM_YYYY = "DD-MM-YYYY";
export const DATE_FORMAT_DD_MM_YYYY_HH_MM = "DD-MM-YYYY hh:mm";
export const DATE_FORMAT_DD_MMM_YYYY = "DD MMMM YYYY";
export const TIME_FORMAT_HH_MM = "HH:mm";
export const DATE_FORMAT_DD_MM = "DD MMM";
